import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        transformOrigin: "center"
    }
});
export default stylesheet;
